@if (!hidden) {
  <div class="airwallex-kyc-widget" [ngStyle]="contentStyle">
    @if (error) {
      <p class="airwallex-kyc-widget__error">{{ error }}</p>
    }
    @if (loading && !error) {
      <p class="airwallex-kyc-widget__loading">Loading verification form…</p>
    }

    @switch (status) {
      @case ('SUBMITTED') {
        <p class="airwallex-kyc-widget__status">
          Your application has been submitted. We'll be in touch once it's reviewed.
        </p>
      }
      @case ('SUCCESS') {
        <p class="airwallex-kyc-widget__status airwallex-kyc-widget__status--success">
          Verification complete.
        </p>
      }
      @case ('FAILURE') {
        <p class="airwallex-kyc-widget__status airwallex-kyc-widget__status--failure">
          Verification was unsuccessful. Contact support to continue.
        </p>
      }
    }

    <div #kycHost class="airwallex-kyc-widget__host"></div>
  </div>
}
